'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import PropertyInputMultipleDomainInput from './PropertyInputMultipleDomainInput';
import PropertyInputMultipleDomainNewValue from './PropertyInputMultipleDomainNewValue';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import PropertyInputMultiplePropertyPopoverBody from './PropertyInputMultiplePropertyPopoverBody';
const propTypes = {
  domains: PropTypes.array.isRequired,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  objectType: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyUp: PropTypes.func,
  property: PropertyPropType.isRequired,
  subjectId: PropTypes.string,
  onUpdatePrimaryDomain: PropTypes.func.isRequired,
  onUpdateSecondaryDomain: PropTypes.func.isRequired,
  onRemoveDomain: PropTypes.func.isRequired,
  onPromoteDomain: PropTypes.func.isRequired,
  onAddNewDomain: PropTypes.func.isRequired,
  showAutoSaveText: PropTypes.bool.isRequired
};

function PropertyInputMultipleDomainPopoverContent({
  domains,
  readOnly,
  disabled,
  objectType,
  onBlur,
  onFocus,
  onKeyUp,
  property,
  subjectId,
  onUpdatePrimaryDomain,
  onUpdateSecondaryDomain,
  onRemoveDomain,
  onPromoteDomain,
  onAddNewDomain,
  showAutoSaveText
}) {
  const [showNewDomainInput, setShowNewDomainInput] = useState(false);

  const handleAddNewDomainInput = () => setShowNewDomainInput(true);

  const handleCancelNewDomainInput = () => setShowNewDomainInput(false);

  const handleSaveNewDomain = newDomain => {
    onAddNewDomain(newDomain);
    setShowNewDomainInput(false);
  };

  const renderDomainInput = (domain, index) => {
    const isPrimary = index === 0;
    return /*#__PURE__*/_jsx(PropertyInputMultipleDomainInput, {
      autoFocus: isPrimary,
      objectType: objectType,
      onBlur: onBlur,
      onChange: isPrimary ? onUpdatePrimaryDomain : _value => onUpdateSecondaryDomain(index, _value),
      onFocus: onFocus,
      onKeyUp: onKeyUp,
      property: property,
      readOnly: readOnly,
      disabled: disabled,
      showError: true,
      subjectId: subjectId,
      value: domain,
      isPrimaryDomain: isPrimary,
      onDelete: onRemoveDomain,
      promoteToPrimary: onPromoteDomain
    }, index);
  };

  const addNewDomainButton = readOnly || disabled ? null : /*#__PURE__*/_jsxs(UIButton, {
    use: "transparent",
    onClick: handleAddNewDomainInput,
    className: "p-left-0",
    disabled: readOnly,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "add",
      size: "xxs",
      color: CALYPSO_DARK
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputMultipleDomain.addDomain"
    })]
  });
  return /*#__PURE__*/_jsxs(PropertyInputMultiplePropertyPopoverBody, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.PropertyInputMultipleDomain.label"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      childClassName: "m-bottom-2",
      children: [domains.map(renderDomainInput), showNewDomainInput ? /*#__PURE__*/_jsx(PropertyInputMultipleDomainNewValue, {
        domains: domains,
        onSave: handleSaveNewDomain,
        onCancel: handleCancelNewDomainInput,
        showAutoSaveText: showAutoSaveText
      }) : null]
    }), addNewDomainButton]
  });
}

PropertyInputMultipleDomainPopoverContent.propTypes = propTypes;
export default PropertyInputMultipleDomainPopoverContent;